export const pagePropsMockData = {
  render: 'server',
  mc: '1',
  theme: '',
  dirRTL: '',
  findHotelLabel: 'Update Search',
  placeholderTextMobile: 'Where next?',
  placeholderTextDesktop: 'Where can we take you?',
  hideDestination: 'false',
  submitAction: 'default',
  showDatesOnMobile: 'false',
  isItForOffersPage: 'false',
  enableTwoBoxForHeaderDates: 'enableTwoBoxForHeaderDates',
  maxGuestPerRoom: '8',
  disableRecentlyViewed: 'false',
  topDestinationslistItems: [],
  dateFormat: 'ddd, MMM DD',
  enableFlexibleSearch: 'true',
  maxChildAge: '17',
  hpBulkSearchEndPoint: '/meetings/search-hotels.mi',
  disableTopDestination: 'false',
  enableRedeemPoints: 'false',
  localDateFormat: 'MM/DD/YYYY',
  searchViewType: 'listview',
  disableFloatingBehavior: 'false',
  orderingRecentlySearchedAndViewed: 'recentSearch',
  disableUsePointCertificates: false,
  specialRatesListItems: [
    {
      specialRatesCode: 'none',
      specialRateslabel: 'Lowest Regular Rate',
      promoCodeEnable: 'false',
    },
    {
      specialRatesCode: 'aaa',
      specialRateslabel: 'AAA/CAA',
      promoCodeEnable: 'false',
    },
    {
      specialRatesCode: 'S9R',
      specialRateslabel: 'Senior Discount',
      promoCodeEnable: 'false',
    },
    {
      specialRatesCode: 'gov',
      specialRateslabel: 'Government & Military',
      promoCodeEnable: 'false',
    },
    {
      specialRatesCode: 'corp',
      specialRateslabel: 'Corp/Promo Code',
      promoCodeEnable: 'false',
    },
  ],
  hideFlexibleDatesCheckbox: 'false',
  enablePadding: 'true',
  src: 'COMPONENT_RESOLVER_URI',
  placeholderTextPopularDestination: 'Popular Destinations',
  domesticDestinationsListItems: [],
  enableMarriottShopPage: 'true',
  enableOverlap: 'false',
  maxNumberOfNights: '9',
  enableNewSearch: 'false',
  hpSearchEndPoint: '/search/findHotels.mi',
  roomListItems: [
    {
      roomQuantity: '1',
    },
    {
      roomQuantity: '2',
    },
    {
      roomQuantity: '3',
    },
    {
      roomQuantity: '4-9',
    },
    {
      roomQuantity: '10-25',
    },
    {
      roomQuantity: '26+',
    },
  ],
  submitActioPrefix: '',
  firstDayOfWeek: '0',
  featuredDestinationsListItems: [],
  disableRecentlySearched: 'false',

  destination: 'Destination',
  checkInLabel: 'CHECK IN',
  checkOutLabel: 'CHECK OUT',
  currentLocationLabel: 'Current Location',
  exactDatesTabText: 'Exact dates',
  flexibleTabText: 'Flexible dates',
  howManyNights: 'How many nights ?',
  roomsGuestsHead: 'Rooms & Guests',
  rooms: 'Rooms',
  room: 'Room',
  guests: 'Guests',
  guest: 'Guest',
  adults: 'Adults',
  children: 'Children',
  ageBasedRatesLabel: 'Age-based rates may be available',
  childAgeRequired: 'Child {x}: Age (Required)',
  reset: 'Reset Fields',
  ratesShopPageHeader: 'Rates',
  selectOneRateLabel: 'Select one rate',
  usePointsCertificates: 'Use Points/Certificates',
  datesPlaceholderText: 'Add Date',
  clear: 'Clear Dates',
  flexibleDates: 'Flexible Dates',
  myDatesFlexibleLabel: 'My dates are flexible',
  currentLocationText: 'Search from current location below.',
  add: 'Add',
  remove: 'Remove',
  cancel: 'Cancel',
  night: 'Night',
  nights: 'Nights',
  done: 'Done',
  clearLabel: 'Clear',
  destinationSearchResult:
    'There are {x} search results. Keyboard users, use up and down arrows to review and enter to select. Touch device users, explore by touch or with swipe gestures.',
  flexible: 'Flexible',
  recentSearchesHeading: 'Recent Searches',
  recentlyViewedHeading: 'Recently Viewed',
  clearRecentLabel: 'Clear Recent',
  lessThanLabel: 'Less than 1',
  ageLabel: 'Age',
  applyLabel: 'Apply',
  specialRatesPoints: 'Special Rates/Points',
  specialRatesShopPageLabel: 'Special Rates',
  edit: 'Edit',
  addCorpOrPromoCode: 'ADD CORP/PROMO CODE',
  clearCTALabel: 'Clear values',
  usePointsConfirmMessage:
    'Marriott Bonvoy points are not available for use when requesting more than 3 rooms.  Click "OK" to request a special group room rate. Click "Cancel" to revise your search.',
  flexibleAlertMessage:
    'Flexible date searches cannot be completed requesting more than 3 rooms. Please revise your search',
  stayDates: 'Dates',
  noResultFound: 'No result found.',
  weekdays: 'S,M,T,W,T,F,S',
  weekdaysLong: 'Sunday,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday',
  months: 'January,February,March,April,May,June,July,August,September,October,November,December',
  selectAMonth: 'Select a month',
  storefrontPropertySearchWidgetErrorMessageRooms: 'storefrontPropertySearchWidgetErrorMessageRooms',
  collapseLabel: 'collapseLabel',
  newSearchLabel: 'newSearchLabel',
  weekdaysShort: 'weekdaysShort',
  monthsShort: 'monthsShort',
  domesticLabel: 'domesticLabel',
  featuredLabel: 'featuredLabel',
  collapseOnPageLoad: false,
  collapseWhenUserUpdates: false,
  disableHotelHeaderAndReviewLinks: false,
  disableHotelReviewLinks: false,
  roomsShortLabel: 'Rooms',
  roomsGuestsHeadShortLabel: 'Rooms & Guests',
  searchGuestsShortLabel: 'Guests',
  searchGuestShortLabel: 'Guests',
  roomShortLabel: 'Rooms',
};
